import React from "react";
import { Message } from "./Message";
import { TypingIndicator } from "./TypingIndicator";
import { Message as MessageType } from "../../types";

interface MessageListProps {
  messages: MessageType[];
  isLoading: boolean;
  messagesEndRef: React.RefObject<HTMLDivElement>;
  isMaximized?: boolean;
  themeMode?: "light" | "dark";
}

export const MessageList: React.FC<MessageListProps> = ({
  messages,
  isLoading,
  messagesEndRef,
  isMaximized = false,
  themeMode = "light",
}) => {
  const isDark = themeMode === "dark";

  return (
    <div
      className={`p-4 space-y-4 overflow-y-auto ${
        isDark ? "bg-[#14161C] text-gray-100" : "bg-white text-gray-800"
      }`}
    >
      {messages.map((message) => (
        <Message
          key={message.id}
          message={message}
          isMaximized={isMaximized}
          themeMode={themeMode}
        />
      ))}
      {isLoading && <TypingIndicator />}
      <div ref={messagesEndRef} />
    </div>
  );
};
